/* eslint-disable no-underscore-dangle */
import React, { useRef, useEffect, useState, useCallback } from "react"
import AutoSizer from "react-virtualized-auto-sizer"
import { ChevronDownIcon } from "@100mslive/react-icons"
import { Box } from "../shared/box"
import RecordedChatMessageItem from "./recorded-chat-message-item"
import { PrimaryButton } from "../shared/button"
import {
  ChatContainer,
  ChatHeaderContainer,
  ChatHeaderWrapper,
  ChatTitle,
  StyledVariableSizeList,
} from "./styles"

const RecordedChatMessage = ({ messages }) => {
  const listRef = useRef(null)
  const [showIndicator, setShowIndicator] = useState(false)

  const rowHeights = useRef({})

  const getRowHeight = (index) => rowHeights.current[index] + 16 || 72

  const setRowHeight = useCallback(
    (index, size) => {
      listRef.current.resetAfterIndex(0)
      rowHeights.current = { ...rowHeights.current, [index]: size }
    },
    [listRef],
  )

  useEffect(() => {
    const currentListRef = listRef?.current?._outerRef
    if (!currentListRef) return

    const isScrolledUp = Math.abs(
      currentListRef.scrollHeight - currentListRef.scrollTop - currentListRef.clientHeight,
    )

    if (isScrolledUp > 67) {
      setShowIndicator(isScrolledUp)
    } else {
      listRef.current.scrollToItem(messages.length - 1)
    }

    const handleScroll = () => {
      const isScrolledToBottom =
        currentListRef.scrollHeight - currentListRef.clientHeight ===
        Math.ceil(currentListRef.scrollTop)

      if (isScrolledToBottom) {
        setShowIndicator(false)
      }
    }

    currentListRef.addEventListener("scroll", handleScroll)

    return () => {
      currentListRef.removeEventListener("scroll", handleScroll)
    }
  }, [messages])

  const scrollToBottom = () => {
    if (listRef.current) {
      listRef.current.scrollToItem(messages.length - 1)
      setShowIndicator(false)
    }
  }

  return (
    <ChatHeaderContainer>
      <ChatHeaderWrapper>
        <ChatTitle>Chat</ChatTitle>
      </ChatHeaderWrapper>
      {messages.length === 0 ? null : (
        <Box
          css={{
            height: "100%",
          }}
          as="div"
        >
          <ChatContainer as="div">
            <AutoSizer>
              {({ height, width }) => (
                <StyledVariableSizeList
                  ref={listRef}
                  height={height}
                  width={width}
                  itemSize={getRowHeight}
                  itemCount={messages.length}
                  style={{
                    overflowX: "hidden",
                  }}
                >
                  {({ index, style }) => (
                    <RecordedChatMessageItem
                      message={messages[index]}
                      index={index}
                      style={style}
                      setRowHeight={setRowHeight}
                    />
                  )}
                </StyledVariableSizeList>
              )}
            </AutoSizer>
            {showIndicator && (
              <PrimaryButton
                onClick={scrollToBottom}
                css={{ opacity: 0.97, position: "absolute", bottom: "0" }}
              >
                New Messages
                <ChevronDownIcon width={16} height={16} />
              </PrimaryButton>
            )}
          </ChatContainer>
        </Box>
      )}
    </ChatHeaderContainer>
  )
}

export default RecordedChatMessage
